module.exports = __webpack_public_path__ + "static/media/info.519bd883.svg";